const { Mfa } = require('../prisma/types');

const MFA_METHOD_ORDER = [Mfa.Email, Mfa.Sms, Mfa.Totp];

function sortMfaMethods(methods) {
  return MFA_METHOD_ORDER.filter((method) => methods.includes(method));
}

module.exports = {
  MFA_METHOD_ORDER,
  sortMfaMethods,
};
